import $ from "jquery";
import {
    crossRecommenderClickHandler,
    crossRecommenderViewHandler
} from "../../common/dataLayer/data-layer-metrica-handlers";
import {GET_NEXT_MATERIAL_EVENT_NAME} from "../../../common/events";

export const MaterialContentRecommendHandlers = () => {
    let observer = new IntersectionObserver(onIntersectionObserve);

    document.addEventListener(GET_NEXT_MATERIAL_EVENT_NAME, function (data) {
        $('.material-content-recommend-item').each(function () {
            observer.observe($(this)[0]);
        });
    });

    $('.material-content-recommend-item').each(function () {
        observer.observe($(this)[0]);
    });

    $(document).on('click', '.material-content-recommend-item', function (event) {
        const data = $(this).data();

        crossRecommenderClickHandler(data.id, data.isNews === '' ? 'post' : 'news', 'insidecontent', '');

        return true;
    });
};

const onIntersectionObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        }

        crossRecommenderViewHandler('insidecontent', '');

        observer.unobserve(entry.target);
    });
};